// extracted by mini-css-extract-plugin
export default {"heart":"footer_heart__yCO6z"};